// extracted by mini-css-extract-plugin
module.exports = {"main":"AssetImage-module__main___1yY6u","spinner":"AssetImage-module__spinner___2AywE","hidden":"AssetImage-module__hidden___2x_X8"};